module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"forgotPassword":"Forgot Password","email":"Email","submit":"Submit","invalidSubject":"Customer with this email was not found"},"de":{"forgotPassword":"Passwort vergessen","email":"Email","submit":"Weiter","invalidSubject":"Kunde mit dieser E-Mail wurde nicht gefunden"}}')
  delete Component.options._Ctor
}
